import { uniqBy } from "lodash";
import { createSelector } from "reselect";

const projects = (state) => state.admin.projects;
const products = (state) => state.admin.products;
const productCatalog = (state) => state.admin.productCatalog;

export const selectLatestProjectId = createSelector(projects, (projects) => {
    let projectID = "";
    for (let i = 0, len = projects.length; i < len; i++) {
        if (!projects[i]?.type?.type?.includes("Club")) {
            projectID = projects[i].projectID;
            break;
        }
    }
    return projectID;
});

export const selectProjects = createSelector([projects], (projects) => {
    return uniqBy(projects || [], "projectID");
});

export const selectProducts = createSelector(products, (products) => uniqBy(products, "ProductID"));

export const selectProductCatalog = createSelector(productCatalog, (productCatalog) => productCatalog);
